export default __webpack_public_path__ + "static/media/top-right-trace.605749df.svg";